import {
  wssEndpointFetchFulfilled,
  wssOpened,
  tryClosingWss,
  wssClosed,
  sendWssMessage,
  parseWssMessage
} from '../actions/wss'
import { raiseError } from '../actions/disconnect'
import { startRTC } from '../actions/app'
import { AGENT_TYPE } from '../actions/agent'

const wssMiddleware = () => {
  return (store) => {
    let webSocket

    function wssEndpointFetchFulfilledAction (payload) {
      const wssEndpoint = payload
      webSocket = new WebSocket(wssEndpoint)

      webSocket.onopen = (/* openEvent */) => {
        store.dispatch(wssOpened())
        store.dispatch(startRTC()) // see logic/app mw
      }

      webSocket.onclose = () => {
        store.dispatch(wssClosed())
      }

      webSocket.onerror = (/* errorEvent */) => {
        const { agent: { type } } = store.getState()
        store.dispatch(raiseError({
          message: `error-portal-connection${(type === AGENT_TYPE.CLASSROOM_AGENT) ? '-classroom' : ''}`,
          error: 'WebSocket error received',
        }))
      }

      webSocket.onmessage = (messageEvent) => {
        let fileReader = new FileReader()
        fileReader.onloadend = () => {
          store.dispatch(parseWssMessage(fileReader.result))
        }
        fileReader.readAsArrayBuffer(messageEvent.data)
      }
    }

    function closeWssConnection () {
      if (webSocket) {
        try {
          webSocket.close()
          webSocket = null
        } catch (errorEvent) {
          const { agent: { type } } = store.getState()
          store.dispatch(raiseError({
            message: `error-portal-connection${(type === AGENT_TYPE.CLASSROOM_AGENT) ? '-classroom' : ''}`,
            error: 'Could not close the websocket connection.',
          }))
        }
      }
    }

    function sendThroughWss (payload) {
      if (webSocket) {
        try {
          webSocket.send(payload)
        } catch (errorEvent) {
          const { agent: { type } } = store.getState()
          store.dispatch(raiseError({
            message: `error-portal-connection${(type === AGENT_TYPE.CLASSROOM_AGENT) ? '-classroom' : ''}`,
            error: 'error sending websocket message',
          }))
        }
      }
    }

    return (next) => (action) => {
      const actions = {
        [wssEndpointFetchFulfilled]: (payload) => wssEndpointFetchFulfilledAction(payload),
        [tryClosingWss]: () => closeWssConnection(),
        [sendWssMessage]: (payload) => sendThroughWss(payload),
      }

      if (actions.hasOwnProperty(action.type)) {
        actions[action.type](action.payload)
      }

      return next(action)
    }
  }
}

export default wssMiddleware
